import * as React from 'react';

export default function useForceUpdate() {
  const [, setX] = React.useState<number>(0);
  return React.useCallback(() => setX(x => x + 1), []);
}
